import React from 'react';
import {Form, Select, Col, Row, message, Radio} from 'antd';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, postFrom } from '../../../../axios';
import {
    API_Merchant_getHsbAccountingRulesList,
    API_Merchant_getHsbMerchantInfoList,
    API_Merchant_getMerchantHsbPayChannelConfigByMerchantId,
    API_Merchant_updateMerchantHsbPayChannelConfig
} from "../../../../axios/config";
import ParticipantsList from './Participants';
import { floatObj } from '../../../../utils';



class HSBChannelConfigAdd extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            merchantId:0,
            title: "惠市宝渠道配置",
            clrgRuleList: [], // 分账规则编号 下拉
            hsbMerchantList:[], // 商户编号 下拉
            formData: {},
        }
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    loadPack = ({ id }) => {

        this.postClrgRuleList();
        this.postHsbMerchantInfoList();
        this.postGet(id)
        this.setState({ loading: true,merchantId: id, title: "惠市宝渠道配置" });
    }



    postClrgRuleList() {
        post({ url: API_Merchant_getHsbAccountingRulesList }).then(res => {
            this.setState({ clrgRuleList: res })
        })
    }

    postHsbMerchantInfoList() {
        post({ url: API_Merchant_getHsbMerchantInfoList }).then(res => {
            this.setState({ hsbMerchantList: res })
        })
    }

    postGet(id) {
        postFrom({ url: API_Merchant_getMerchantHsbPayChannelConfigByMerchantId, data: { merchantId: id } }).then(res => {
            this.setState({  formData: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    postSubmit(values) {
        this.setState({ loading: true });
        post({ url: API_Merchant_updateMerchantHsbPayChannelConfig, data: values }).then(res => {
            message.success('操作成功');
            this.props.handleGetList();
            this.handleCancel();
        }).catch(err => {
            message.error(err.message || '操作失败');
            this.setState({ loading: false });
        })
    }

  

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({ formData: {  }, loading: false, title: "惠市宝渠道配置" });
    }


  

    handleOk = () => {
        if (!this.state.formData.status) return message.warning('请选择状态')
        if (!this.state.formData.mktMrchId) return message.warning('请选择商家编号')
        if (!this.state.formData.configMemberList || this.state.formData.configMemberList.length === 0) return message.warning('分账规则参与方配置不能为空')


        let scaleTotal = 0
        for(let i = 0; i < this.state.formData.configMemberList.length; i++) {
            const item = this.state.formData.configMemberList[i]
            if (!item.mktMrchId) return message.warning('分账规则参与方配置中商户编号不能为空')
            if (!this.state.formData.clrgRuleId ) {
                if (!item.scale) return message.warning('分账规则参与方配置中比例不能为空')
                if (item.scale> 1 || item.scale < 0) return message.warning('分账规则参与方配置中比例在 0 ~ 1之间')
                scaleTotal = floatObj().add(scaleTotal, item.scale) 
            }
        }
        if (!this.state.formData.clrgRuleId && scaleTotal !==1) return message.warning('分账规则参与方配置中比例累加必须等于1')

        const data = {}
        
        data.merchantId = this.state.merchantId
        data.memberList = this.state.formData.configMemberList
        data.status = this.state.formData.status
        data.clrgRuleId = this.state.formData.clrgRuleId
        data.mktMrchId = this.state.formData.mktMrchId
        this.postSubmit(data)
      
    }

    handleChange(data) {
        this.setState(state => {
            state.formData = {...state.formData, ...data}
            return state
        })
    }

    handleParticipantsChange = (data) => {
        const configMemberList = data.map((e,i) => {
            if(!this.state.formData.clrgRuleId) {
                e.seqNo = i + 1
            }
            return e
        })
        this.handleChange({ configMemberList })
    }

    handleclrgRuleIdChange = (e) => {
        const clrgRule = this.state.clrgRuleList.find(item => item.clrgRuleId === e) || {}
        const configMemberList = (clrgRule.rulesMemberListList || []).map(item => ({ seqNo: item.seqNo }))
        this.handleChange({ clrgRuleId: e, configMemberList })
    }

    render() {
     

        return <ModalDom
                    title={this.state.title}
                    visible={!!this.props.visible}
                    loading={!!this.state.loading}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
               >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    <Row>
                        <Col span={24}>
                            <DetailTitle title="基础信息配置" />
                            <CustomRow>
                                <CustomCol label="支付渠道状态">
                                    <Radio.Group value={this.state.formData.status} onChange={e => this.handleChange({ status: e.target.value })}>
                                        <Radio value={1}>启用</Radio>
                                        <Radio value={2}>禁用</Radio>
                                    </Radio.Group>
                                </CustomCol>
                                <CustomCol label="商家编号">
                                    <Select value={this.state.formData.mktMrchId } onChange={e => this.handleChange({ mktMrchId: e})}>
                                        {this.state.hsbMerchantList.map(e => (
                                            <Select.Option key={e.mktMrchId} value={e.mktMrchId}>{e.mktMrchId}</Select.Option>
                                        ))}
                                    </Select>
                                </CustomCol>
                            </CustomRow>
                            <DetailTitle title="分账规则配置" />
                            <CustomRow  >
                                <CustomCol label="分账规则编号" required={false}>
                                 
                                    <Select  value={this.state.formData.clrgRuleId} onChange={(e) => this.handleclrgRuleIdChange(e)} allowClear>
                                        {this.state.clrgRuleList.map(e => (
                                            <Select.Option key={e.clrgRuleId} value={e.clrgRuleId} >{e.clrgRuleId}</Select.Option>
                                        ))}
                                    </Select>
                                </CustomCol>
                            </CustomRow>
                            <DetailTitle title="分账规则参与方配置" />
                            <ParticipantsList 
                                formData={this.state.formData}  
                                clrgRuleList={this.state.clrgRuleList}
                                hsbMerchantList={this.state.hsbMerchantList} 

                                onChange={this.handleParticipantsChange}
                            />
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    
}

export default HSBChannelConfigAdd


// WEBPACK FOOTER //
// ./src/page/Merchant/components/HsbChannelConfigAdd/index.js